import { render } from "./WKFooter.vue?vue&type=template&id=62bf35d3&scoped=true"
import script from "./WKFooter.vue?vue&type=script&lang=js"
export * from "./WKFooter.vue?vue&type=script&lang=js"

import "./WKFooter.vue?vue&type=style&index=0&id=62bf35d3&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\v202008\\wike-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bf35d3"]])

export default __exports__